import { addDiscountModelApi, getDiscountModelApi, getUserDiscountApi } from 'configs'
import { showNotification } from 'redux/Notification/Action'

export const GET_DISCOUNT_MODEL = 'GET_DISCOUNT_MODEL'
export const getDiscountModel = () => async dispatch => {
  try {
    const { data } = await getDiscountModelApi()
    dispatch({ type: GET_DISCOUNT_MODEL, payload: data })
  } catch (error) {}
}
export const ADD_DISCOUNT_MODEL = 'ADD_DISCOUNT_MODEL'
export const addDiscountModel = (formData, setLoading, onClose) => async dispatch => {
  try {
    const { data } = await addDiscountModelApi(formData)
    console.log('🚀 ~ file: actions.js ~ line 10 ~ data', data)
    setLoading(false)
    onClose()
    dispatch(
      showNotification({
        message: 'Your Discount Time Update Successfully',
        massageType: 'success',
      }),
    )
    dispatch({ type: ADD_DISCOUNT_MODEL, payload: data })
  } catch (error) {
    console.log(error)
    dispatch(
      showNotification({
        message: error.Error || 'Some error happened, Please try again',
        massageType: 'error',
      }),
    )
  }
  setLoading(false)
}

export const GET_USER_DISCOUNT = 'GET_USER_DISCOUNT'
export const getUserDiscountData = () => async dispatch => {
  const { data } = await getUserDiscountApi()
  data && dispatch({ type: GET_USER_DISCOUNT, payload: data })
}
